document.addEventListener("DOMContentLoaded", function () {
  var testimonialSwiper = new Swiper('.testimonials-swiper', {
    slidesPerView: 3,
    spaceBetween: 24,
    navigation: {
      nextEl: '.testimonials-button-next',
      prevEl: '.testimonials-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        pagination: {
          el: '.testimonials-pagination',
          clickable: true,
        }
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
        pagination: false
      }
    }
  });
});
